import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Text } from 'rebass';
import Entry from '../entry';

export default () => {
  const title = '1. Find the Turle Doves';
  const hints = [];
  const assignment = 'Find the missing turtle doves.';
  const data = useStaticQuery(graphql`
    query {
      withDoves: file(relativePath: { eq: "withDoves.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      assignment={assignment}
    >
      <Text my={2}> The Turtle Doves are located near the fireplace at the Student Union. </Text>
      <Img fluid={data.withDoves.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh' }}
              imgStyle={{ objectFit: 'contain' }}
      />

    </Entry>
  )

};
